import Reflux from 'reflux';
const $ = jQuery;
const UrlAction = Reflux.createActions(['push', 'process', 'preProcess']);

UrlAction.push.preEmit = (data) => {
  $('#LoadTime').fadeIn(300);
  setTimeout(() => {
    UrlAction.process(data);
  }, 500);
};
export default UrlAction;



// WEBPACK FOOTER //
// ./assets/src/frontend/urlhandler/urlHandlerActions.js